import React, { FC, memo } from 'react';
import { InputNumber, Select, Space } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';

const DimensionMap = {
    By_Quantity: 1,
    By_Time: 2,
    No_Limit: 3,
};

export interface TemplateProps {
    value?: {
        cycle?: number;
        dimensions?: number;
        limit?: number;
    };
    onChange?: (value: TemplateProps['value']) => void;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { value, onChange } = props;

    return (
        <Space>
            <Select
                options={[
                    {
                        value: 1,
                        label: /* 每日 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.daily,
                    },
                    {
                        value: 2,
                        label: /* 每周 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.weekly,
                    },
                ]}
                placeholder={/* 请选择周期 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.pleaseSelectAPeriod}
                value={value?.cycle}
                onChange={(e) =>
                    onChange?.({
                        ...value,
                        cycle: e,
                    })
                }
            />

            <Select
                options={[
                    {
                        value: DimensionMap.By_Quantity,
                        label: /* 按数量 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.byQuantity,
                    },
                    {
                        value: DimensionMap.By_Time,
                        label: /* 按时长 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.longOnTime,
                    },
                    {
                        value: DimensionMap.No_Limit,
                        label: /* 不设上限 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.noUpperLimit,
                    },
                ]}
                placeholder={/* 请选择计算维度 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.pleaseSelectACalculationDimension}
                value={value?.dimensions}
                onChange={(e) =>
                    onChange?.({
                        ...value,
                        dimensions: e,
                        limit: undefined,
                    })
                }
            />

            {value?.dimensions === DimensionMap.By_Quantity ? (
                <InputNumber
                    min={1}
                    precision={0}
                    value={value.limit}
                    onChange={(e) => onChange?.({ ...value, limit: e })}
                    placeholder={/* 请输入 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.pleaseEnter}
                />
            ) : value?.dimensions === DimensionMap.By_Time ? (
                <Space>
                    <InputNumber
                        min={0.1}
                        precision={1}
                        value={value.limit}
                        onChange={(e) => onChange?.({ ...value, limit: e })}
                        placeholder={/* 请输入 */UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.pleaseEnter}
                    />
                    <span>{/* 小时 */}{UdeskLocales['current'].pages.speechRecognition.components.aSRFilterMethod.components.sampleUpperLimit.index.hours}</span>
                </Space>
            ) : null}
        </Space>
    );
});

export default Template;
